var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("Welcome to "+_vm._s(_vm.htmlname))]),_vm._v(" "),_c('h2',[_vm._v("...Welcome...")]),_vm._v(" "),_c('div',{staticClass:"icp-buttom"},[_vm._v("\n    "+_vm._s(_vm.htmlname)+" | "+_vm._s(_vm.copyright)+" | "),_c('a',{attrs:{"href":"http://beian.miit.gov.cn"}},[_vm._v(_vm._s(_vm.websiterecord))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67365152","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
// module id = null
// module chunks = 